const SEPARATORS = /[\s()/.-]/g;

export const normalizePhone = (value: string): string => {
  const compact = value.trim().replace(SEPARATORS, '');
  if (/^\+36\d{8,9}$/.test(compact)) return compact;
  if (/^0036\d{8,9}$/.test(compact)) return `+36${compact.slice(4)}`;
  if (/^36\d{8,9}$/.test(compact)) return `+${compact}`;
  if (/^06\d{8,9}$/.test(compact)) return `+36${compact.slice(2)}`;
  return compact;
};

export const formatPhone = (value: string): string => {
  const normalized = normalizePhone(value);
  if (!/^\+36\d{8,9}$/.test(normalized)) return value;
  const national = normalized.slice(3);
  const areaLength = national.startsWith('1') ? 1 : 2;
  const area = national.slice(0, areaLength);
  const rest = national.slice(areaLength);
  return `+36 ${area} ${rest.slice(0, 3)} ${rest.slice(3)}`;
};

export const telHref = (value: string): string => `tel:${normalizePhone(value)}`;
